import { Block as BlockIcon } from 'components/icons';
import { Tooltip } from 'components/ui/tooltip';
import React from 'react';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations.ts';

interface BlockedProps {
    className?: string;
    tooltipText?: string;
}

const Blocked: React.FC<BlockedProps> = ({ className, tooltipText }) => {
    const label = tooltipText ? t(tooltipText) : undefined;

    const icon = (
        <BlockIcon
            role={label ? 'img' : undefined}
            aria-label={label}
            // Glyphs default to aria-hidden unless given a `titleAccess`; without this the label is never read.
            aria-hidden={label ? false : undefined}
            className={cn('bg-error-light text-error rounded-[20%] p-[5px] text-[23px]', className)}
        />
    );

    if (!label) {
        return icon;
    }

    return (
        <Tooltip content={label}>
            <span className="inline-flex">{icon}</span>
        </Tooltip>
    );
};

export default Blocked;
